import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class TAGuard implements CanActivate {
  role: string;
  token: string;
  isTA: boolean;

  constructor(private _authService: AuthService, private _router: Router) {
    this.token = this._authService.getToken();
  }

  canActivate() {
    return this._authService.getRole().pipe(
      map(r => {
        this.role = r.result.ROLE;
        this.isTA = r.result.IS_TA;

        if (this.role === 'user' && this.isTA) {
          return true;
        } else {
          this._router.navigate(['/']);
          return false;
        }
      }),
      catchError(() => {
        this._router.navigate(['/']);
        return of(false);
      })
    )
  }

}
